import { LookupTab } from '../../FrontendLookups';

export const productsTableStructure: LookupTab[] = [
  {
    name: 'all',
    structure: {
      tableHeaders: [
        {
          label: 'Lookup',
          align: 'left',
          sortValue: null,
        },
        {
          label: 'Product',
          align: 'left',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: null,
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customer`,
        },
        {
          type: 'customerProduct',
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'onboarding',
    structure: {
      tableHeaders: [
        {
          label: 'Lookup',
          align: 'left',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: 'score',
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customer`,
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'phone',
    structure: {
      tableHeaders: [
        {
          label: 'PHONE NUMBER',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: 'score',
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customerPhone`,
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'email',
    structure: {
      tableHeaders: [
        {
          label: 'Email',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: 'score',
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customerEmail`,
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'ip',
    structure: {
      tableHeaders: [
        {
          label: 'IP Address',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: 'score',
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customerIpAddress`,
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'domain',
    structure: {
      tableHeaders: [
        {
          label: 'lookup',
          sortValue: null,
        },
        {
          label: 'product',
          sortValue: null,
        },
        {
          label: 'Customer id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: null,
        },
        {
          label: 'Date',
          sortValue: null,
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customerDomainIntelligence`,
        },
        {
          type: 'product',
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'login',
    structure: {
      tableHeaders: [
        {
          label: 'Login',
          sortValue: null,
        },
        {
          label: 'Customer Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: 'score',
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [
        {
          type: 'customerData',
          pathToDetail: `customerDomainIntelligence`,
        },
        {
          type: 'id',
        },
        {
          type: 'level',
        },
        {
          type: 'score',
        },
        {
          type: 'date',
        },
        {
          type: 'action',
        },
      ],
    },
  },
  {
    name: 'bot-detection',
    isAdminOnly: true,
    structure: {
      tableHeaders: [
        {
          label: 'Main Data',
          sortValue: null,
        },
        {
          label: 'Session Id',
          sortValue: null,
        },
        {
          label: 'Cluster',
          sortValue: null,
        },
        {
          label: 'Score',
          sortValue: null,
        },
        {
          label: 'Date',
          sortValue: 'date',
        },
        {
          label: '',
          sortValue: null,
        },
      ],
      tableBody: [],
    },
  },
];
